import $ from "jquery";
import "slick-carousel";
import "@fortawesome/fontawesome-free";
import "video.js";
import * as pdfLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
pdfLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

(() => {
  if (!document.getElementById("vid-carousel")) {
    return false;
  }

  const thumbnail = $(".kiosksmart__second-thumbnail-wrapper");
  const main = $(".kiosksmart__main");
  const btnright = $(".btn-right");
  const btnleft = $(".btn-left");
  const dataimage = $(".kiosksmart__second-carousel-item:first-child").attr(
    "data-img"
  );
  const datatitle = $(".kiosksmart__second-carousel-item:first-child").attr(
    "data-title"
  );
  const dataurl = $(".kiosksmart__second-carousel-item:first-child").attr(
    "data-url"
  );
  const dataprop = $(".kiosksmart__second-carousel-item:first-child").attr(
    "data-prop"
  );
  const datadesc = $(".kiosksmart__second-carousel-item:first-child").attr(
    "data-desc"
  );
  const videoplayer = $(".video-player");

  function playVideo(videoSource, type) {
    var videoElm = document.getElementById("asml-video");
    var videoSourceElm = document.getElementById("video-source");

    videoSourceElm.src = videoSource;
    videoSourceElm.type = type;

    videoElm.load();
    videoElm.play();
  }

  function pauseVideo() {
    var videoElm = document.getElementById("asml-video");
    videoElm.pause();
  }

  let pdfDoc = null,
    pageNum = 1,
    pageIsRendering = false,
    pageNumIsPending = null;

  const scale = 1.5,
    canvas = document.querySelector("#pdf-render"),
    ctx = canvas.getContext("2d");

  const renderPage = (num) => {
    pageIsRendering = true;

    pdfDoc.getPage(num).then((page) => {
      const viewport = page.getViewport({ scale });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderCtx = {
        canvasContext: ctx,
        viewport,
      };

      page.render(renderCtx).promise.then(() => {
        pageIsRendering = false;

        if (pageNumIsPending !== null) {
          renderPage(pageNumIsPending);
          pageNumIsPending = null;
        }
      });

      document.querySelector("#page-num").textContent = num;
    });
  };

  const queueRenderPage = (num) => {
    if (pageIsRendering) {
      pageNumIsPending = num;
    } else {
      renderPage(num);
    }
  };
  const showPrevPage = () => {
    if (pageNum <= 1) {
      return;
    }
    pageNum--;
    queueRenderPage(pageNum);

    $("#pdf-render").fadeOut(0);
    $("#pdf-render").fadeIn(1000);
  };

  const showNextPage = () => {
    if (pageNum >= pdfDoc.numPages) {
      return;
    }
    pageNum++;
    queueRenderPage(pageNum);

    $("#pdf-render").fadeOut(0);
    $("#pdf-render").fadeIn(1000);
  };

  function init() {
    $("#vid-carousel").slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $("#slider-prev"),
      nextArrow: $("#slider-next"),
    });
  }

  if (thumbnail) {
    thumbnail.html(
      "<img src=" +
        dataimage +
        " alt=video-dummy class=thumbnail-vid id=thumbnail-vid>"
    );

    // main.append(
    //   "<img src=" + dataimage + " alt=video dummy class=main-vid id=main-vid>"
    // );
    videoplayer.removeClass("translucent");
    $("#asml-video").attr("data-url", dataurl);
    $(".kiosksmart__second-thumbnail-title-name").append(datatitle);
    $(".kiosksmart__second-thumbnail-title-desc-text").append(datadesc);
    $(".kiosksmart__second-thumbnail-title-duration").append(dataprop);
  }

  $(".kiosksmart__second-carousel-item").click(function () {
    const image = $(this).attr("data-img");
    const format = $(this).attr("data-format");
    const url = $(this).attr("data-url");
    const title = $(this).attr("data-title");
    const prop = $(this).attr("data-prop");
    const desc = $(this).attr("data-desc");

    thumbnail.html(
      "<img src=" +
        image +
        " alt=video dummy class=thumbnail-vid id=thumbnail-vid>"
    );

    $(".kiosksmart__second-thumbnail-title-name").html(
      "<span>" + title + "</span>"
    );
    $(".kiosksmart__second-thumbnail-title-desc-text").html(
      "<span>" + desc + "</span>"
    );
    $(".kiosksmart__second-thumbnail-title-duration").html(
      "<span>" + prop + "</span>"
    );

    if (format == "SLIDE SHOW") {
      pdfLib.getDocument(url).promise.then((pdfDoc_) => {
        pdfDoc = pdfDoc_;

        document.querySelector("#page-count").textContent = pdfDoc.numPages;

        renderPage(pageNum);
      });

      document
        .querySelector("#prev-page")
        .addEventListener("click", showPrevPage);
      document
        .querySelector("#next-page")
        .addEventListener("click", showNextPage);
      videoplayer.addClass("translucent");
      btnright.removeClass("right");
      btnleft.removeClass("left");
      $(".page-info").removeClass("hidden");
      $("#page-info").removeClass("page-info-out").addClass("page-info");

      $(".play-btn-container").addClass("translucent");
      $("#video-source").attr("src", "");
      pauseVideo();

      setTimeout(function () {
        $(".main-vid").remove();
        $(".slide-only").fadeIn(0);
        $(".slide-only").fadeIn(200);
        $(".slide-only").addClass("hidden");
      }, 1000);
      $(".second-vid").removeClass("hidden");

      if ($(!".slide-only").length) {
        main.append("<div class=slide-only></div>");
      }

      //
    } else {
      // if (!$("#main-vid").length) {
      // }

      btnright.addClass("right");
      btnleft.addClass("left");
      // videoplayer.removeClass("translucent");

      $(".play-btn-container").removeClass("translucent");
      $("#asml-video").attr("data-url", url);

      if (!$(".page-info-out").length) {
        $("#page-info").removeClass("page-info").addClass("page-info-out");
      }

      pauseVideo();
      $("#pdf-render").removeClass("second-vid").addClass("fadeout");
      setTimeout(function () {
        $("#pdf-render").removeClass("fadeout").addClass("second-vid");
        $(".second-vid").addClass("hidden");
        $(".slide-only").remove();
      }, 1000);
    }
  });

  $(".play-btn-container-play").click(function () {
    const url = $("#asml-video").attr("data-url");
    const type = $("#asml-video").attr("data-type");

    $("#main-vid").remove();
    $(".play-btn-container").addClass("translucent");
    playVideo(url, type);
  });

  init();
})();
